// Colors of the program health (sante.md, « Couleurs »): off in v1, on with VITE_PROGRAM_HEALTH_LEVELS=true at build.
// Kept out of program-health.ts, which the e2e specs import outside Vite.
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
//@ts-expect-error
export const LEVELS_ON = import.meta.env.VITE_PROGRAM_HEALTH_LEVELS === 'true'
